













import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { stopBodyScroll } from '@utils/index'
import { Overlay } from 'vant'

@Component({
  components: {
    [Overlay.name]: Overlay,
  },
})
export default class PopAd extends Vue {
  @Prop({ default: false }) readonly show!: boolean
  @Prop({ default: () => ({}) }) readonly popad!: any

  close(e: MouseEvent) {
    const target = e.target as HTMLElement
    if (target.className === 'wrapper') {
      this.$emit('hide')
    }
  }

  @Watch('show')
  onChangeShow(val: boolean) {
    stopBodyScroll(val)
  }

  popAdClick() {
    if (this.popad.linkUrl) {
      this.$emit('hide')
    }
  }
}
